var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketAct1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5513 14H3.44867C1.54282 14 0 12.3754 0 10.3686V3.6314C0 1.62457 1.54282 0 3.44867 0H12.5513C14.4572 0 16 1.62457 16 3.6314V10.3686C16 12.3754 14.4572 14 12.5513 14ZM3.44867 0.850512C1.9966 0.850512 0.807714 2.10239 0.807714 3.6314V10.3686C0.807714 11.8976 1.98752 13.1495 3.44867 13.1495H12.5513C14.0034 13.1495 15.1923 11.9072 15.1923 10.3686V3.6314C15.1923 2.10239 14.0125 0.850512 12.5513 0.850512H3.44867Z",
    fill: "url(#paint0_linear_54_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03516 9.04985L6.00794 13.2451H3.45774L3.47589 9.07852L2.25978 8.35224L2.22348 5.31333L3.53034 4.50105L3.54849 6.48876L4.73738 7.18637L5.91718 6.46009L5.89903 4.48193L7.21497 5.256L7.2422 8.2949L6.03516 9.04985Z",
    fill: "url(#paint1_linear_54_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8673 7.41572H9.39309C9.15713 7.41572 8.97562 7.23415 8.97562 6.99525C8.97562 6.75634 9.1662 6.57477 9.39309 6.57477H13.8673C14.1032 6.57477 14.2847 6.75634 14.2847 6.99525C14.2847 7.23415 14.0942 7.41572 13.8673 7.41572Z",
    fill: "url(#paint2_linear_54_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8673 5.33241H9.39309C9.15713 5.33241 8.97562 5.15084 8.97562 4.91193C8.97562 4.67303 9.1662 4.49146 9.39309 4.49146H13.8673C14.1032 4.49146 14.2847 4.67303 14.2847 4.91193C14.2847 5.15084 14.0942 5.33241 13.8673 5.33241Z",
    fill: "url(#paint3_linear_54_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6149 9.49897H9.30233C9.12082 9.49897 8.97562 9.31741 8.97562 9.0785C8.97562 8.83959 9.12082 8.65802 9.30233 8.65802H12.6149C12.7964 8.65802 12.9416 8.83959 12.9416 9.0785C12.9416 9.31741 12.7964 9.49897 12.6149 9.49897Z",
    fill: "url(#paint4_linear_54_56)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_54_56",
    x1: 0,
    y1: 7.00478,
    x2: 16,
    y2: 7.00478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465EE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_54_56",
    x1: 2.22348,
    y1: 8.85873,
    x2: 7.2422,
    y2: 8.85873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465EE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_54_56",
    x1: 8.96654,
    y1: 7.0048,
    x2: 14.2847,
    y2: 7.0048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465EE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_54_56",
    x1: 8.96654,
    y1: 4.92149,
    x2: 14.2847,
    y2: 4.92149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465EE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_54_56",
    x1: 8.96654,
    y1: 9.0785,
    x2: 12.9416,
    y2: 9.0785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465EE9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketAct1);
export default __webpack_public_path__ + "static/media/ticket Act 1.e79d77353c81c1cb9f5323349861f1d0.svg";
export { ForwardRef as ReactComponent };